import React, { useState, useEffect } from "react";
import useCobroExAlumnos from "../hooks/useCobroExAlumnos";
import useValidacionPago from "../hooks/useValidacionPago";
import useHistorialPagos from "../hooks/useHistorialPagos";
import VistaCobroExAlumnos from "./VistaCobroExAlumnos";
import VistaValidarPago from "./VistaValidarPago";
import VistaHistorial from "./VistaHistorial";

// Reutiliza los mismos hooks/vistas de "pendientes por validar" e "historial"
// que ya usa el alumno normal: ambos endpoints funcionan sobre cualquier
// codigo_alumno/matricula, sin importar si es real o la matricula ficticia
// generica de ex-alumnos.
const CobroExAlumnos = ({ user, catalogoConceptos }) => {
  const [vistaActual, setVistaActual] = useState("cobro"); // 'cobro' | 'historial' | 'validar'

  // El Administrador puede consultar pendientes de cualquier plantel pero
  // nunca valida pagos; cualquier cajero real (rol 2 o 3) si puede.
  const rolCajero = String(localStorage.getItem("cajero_rol"));
  const puedeValidar = rolCajero === "2" || rolCajero === "3";

  const cobroProps = useCobroExAlumnos(user, catalogoConceptos);
  const { referencia } = cobroProps;

  // Representa la referencia generica como si fuera el "alumno seleccionado"
  // que esperan estos hooks (solo usan .matricula).
  const entidadFicticia = referencia ? { matricula: referencia.matricula, nombre: referencia.nombre } : null;

  const validacionProps = useValidacionPago(user?.id_usuario, entidadFicticia);
  const { historialPagos, cargandoHistorial, obtenerHistorialAlumno } = useHistorialPagos();

  useEffect(() => {
    if (vistaActual === "validar" && referencia) {
      validacionProps.buscarReferenciasPendientes(referencia.matricula);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vistaActual, referencia]);

  useEffect(() => {
    if (vistaActual === "historial" && referencia) {
      obtenerHistorialAlumno(referencia.matricula);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vistaActual, referencia]);

  const encabezadoSecundario = (titulo) => (
    <div className="catalogo-section" style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <div>
        <h2 style={{ color: "#003366", margin: "0 0 8px 0", fontSize: "22px" }}>{titulo}</h2>
        <p style={{ color: "#666", margin: 0, fontSize: "14px" }}>
          <strong>Plantel:</strong> {user?.nombre_plantel} &nbsp;|&nbsp; <strong>Referencia:</strong> {referencia?.matricula}
        </p>
      </div>
      <button
        className="btn-logout"
        onClick={() => setVistaActual("cobro")}
        style={{ width: "auto", padding: "12px 24px", backgroundColor: "#d9534f" }}
      >
        ← Volver al Cobro
      </button>
    </div>
  );

  if (vistaActual === "historial") {
    return (
      <div style={{ marginTop: "20px" }}>
        {encabezadoSecundario("Historial de Pagos de Ex-alumnos")}
        <VistaHistorial cargandoHistorial={cargandoHistorial} historialPagos={historialPagos} />
      </div>
    );
  }

  if (vistaActual === "validar") {
    return (
      <div style={{ marginTop: "20px" }}>
        {encabezadoSecundario("Validar Pagos de Ex-alumnos")}
        <VistaValidarPago {...validacionProps} puedeValidar={puedeValidar} />
      </div>
    );
  }

  return (
    <VistaCobroExAlumnos
      {...cobroProps}
      onVerHistorial={() => setVistaActual("historial")}
      onVerValidar={() => setVistaActual("validar")}
    />
  );
};

export default CobroExAlumnos;
